var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],class:'badge badge-address-validation badge-' + _vm.variant,attrs:{"title":_vm.valueTxt}},[_c('i',{class:'fa ' + _vm.icon}),_vm._v(" "),(_vm.type == 'lg')?_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.valueTxt))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }